/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_TcInputs */



/**
* | output |
* | --- |
* | "TC" |
*
* @param {Ccsl_Export_Header_TcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_tc = /** @type {((inputs?: Ccsl_Export_Header_TcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_TcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("TC")
	if (locale === "de") return /** @type {LocalizedString} */ ("TC")
	if (locale === "it") return /** @type {LocalizedString} */ ("TC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ТК")
	if (locale === "es") return /** @type {LocalizedString} */ ("TC")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("TC")
	if (locale === "ja") return /** @type {LocalizedString} */ ("TC")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीसी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("TC")
	return /** @type {LocalizedString} */ ("TC")
});